import React, { useState, useRef, useEffect } from "react";
import { Menu, MenuItem, ProSidebar, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { Box, Typography } from "@mui/material";
import { SelectPicker, Placeholder } from 'rsuite';
import ipo from "../images/ipo.svg";
import Request from "../images/Request.svg";
import MismatchedData from "../images/MismatchedData.svg";
import { callLogoutAPI } from '../Services/logoutService';
import { Navigate, useNavigate } from 'react-router-dom';
import { ChakraProvider, useToast, Wrap } from "@chakra-ui/react";
import crowdWhite from "../images/IconCrowdfundingWhite.svg";
import crowdBlack from "../images/IconCrowdfunding.svg";

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [selectedMenuItem, setSelectedMenuItem] = useState('');
  const [openSubMenu, setOpenSubMenu] = useState('');
  const sidebarRef = useRef(null);
  const currentLocation = useLocation();

  const fullName = sessionStorage.getItem('full_name');
  const isAdmin = sessionStorage.getItem("isAdmin");
  const navigate = useNavigate();
  const toast = useToast();
  const toastIdRef = React.useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsCollapsed(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Set the open submenu based on the current location
     if (currentLocation.pathname.startsWith("/CrowdLeads") || currentLocation.pathname.startsWith("/CrowdLeads_NonAcc"))  {
      setOpenSubMenu('Stocks');
    } 
    else if (currentLocation.pathname.startsWith("/Logout")) {
      setOpenSubMenu('Account');
    } else {
      setOpenSubMenu('');
    }
  }, [currentLocation]);

  const handleMouseEnter = () => {
    setIsCollapsed(false);
  };

  const handleMouseLeave = () => {
    setIsCollapsed(false);
  };

  const handleMouseMove = () => {
    setIsCollapsed(false);
  };

  const handleSidebarClick = (event) => {
    event.stopPropagation();
  };

  const handleOutsideClick = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsCollapsed(true); // Close the sidebar drawer
    }
  };

  // Add event listener to handle outside clicks
  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);


  const handleLogout = async () => {
  setSelectedMenuItem('Logout');
  setOpenSubMenu('Logout');

  
  const result = await callLogoutAPI('manual');
  console.log(result);
  if (result.status == 'success') {
     toastIdRef.current = toast({ description: result.message, status: "success", duration: 5000, isClosable: true, position: "bottom", });
     navigate('/');
    sessionStorage.clear();
  }
  else{
  toastIdRef.current = toast({ description: result.message, status: "error", duration: 5000, isClosable: true, position: "bottom", });
  }
};


  return (
    <>
      <ChakraProvider resetCSS={false}>
            {" "}
            <Wrap> </Wrap>{" "}
          </ChakraProvider>

      <Box onMouseMove={handleMouseMove}>
        <div id="sidebarTrigger" onClick={() => setIsCollapsed(!isCollapsed)}></div>
        <ProSidebar
          collapsed={isCollapsed}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          ref={sidebarRef}
          styles={{
            transition: 'transform 0.10s ease', // Adjust the transition duration here (0.5s)
            transform: isCollapsed ? 'translateX(-260px)' : 'translateX(0)'
          }}
        >
          <Menu iconShape="square">
            <Box>
              <Typography
                variant="h6"
                sx={{ m: "15px 0 5px 20px" }}
              >
               Login By : {fullName}
              </Typography>

              <MenuItem 
                className={selectedMenuItem === 'Dashboard' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('Dashboard'); setOpenSubMenu('Dashboard'); }}
                active={currentLocation.pathname === "/Dashboard"}
              >
                <i className="icon-home"></i> <Link to="/Dashboard">Dashboard</Link> 
              </MenuItem>


<MenuItem 
                className={selectedMenuItem === 'Investors' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('Investors'); setOpenSubMenu('Investors'); }}
                active={currentLocation.pathname === "/Investors"}
              >
                <i className="custom-icon icon-graph"></i> <Link to="/Investors">Investors</Link> 
              </MenuItem>





              <MenuItem 
                className={selectedMenuItem === 'Leads' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('Leads'); setOpenSubMenu('Leads'); }}
                active={currentLocation.pathname === "/Leads"}
              >
                <i className="custom-icon icon-graph"></i> <Link to="/Leads">Dealmaker Leads</Link> 
              </MenuItem>


   <SubMenu 
                title={<> <img 
        src={
          openSubMenu === 'Crowdfunding' || 
          selectedMenuItem === 'CrowdLeads' || 
          selectedMenuItem === 'CrowdLeads_NonAcc'
            ? crowdBlack 
            : crowdWhite
        } 
        alt="Crowdfunding"
      />  Crowdfunding Leads</>}
                open={openSubMenu === 'Crowdfunding'} 
                onOpen={() => setOpenSubMenu('Crowdfunding')} 
                onClick={() => setOpenSubMenu('Crowdfunding')}
              >

                  <MenuItem 
                  className={selectedMenuItem === 'CrowdLeads' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('CrowdLeads'); setOpenSubMenu('CrowdLeads')}}
                  active={currentLocation.pathname === "/CrowdLeads"}
                >
                  <Link to="/CrowdLeads">Accredited</Link>
                </MenuItem> 


                   <MenuItem 
                  className={selectedMenuItem === 'CrowdLeads_NonAcc' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('CrowdLeads_NonAcc'); setOpenSubMenu('CrowdLeads_NonAcc')}}
                  active={currentLocation.pathname === "/CrowdLeads_NonAcc"}
                >
                  <Link to="/CrowdLeads_NonAcc">Non Accredited</Link>
                </MenuItem> 


                                
              </SubMenu> 

               
              

              <MenuItem 
                className={selectedMenuItem === 'WaitingList' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('WaitingList'); setOpenSubMenu('WaitingList'); }}
                active={currentLocation.pathname === "/WaitingList"}
              >
                <i className="custom-icon icon-graph"></i> <Link to="/WaitingList">Waitlist</Link> 
              </MenuItem>

{isAdmin != 0 && (

                <MenuItem 
                className={selectedMenuItem === 'UserLogs' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('UserLogs'); setOpenSubMenu('UserLogs'); }}
                active={currentLocation.pathname === "/UserLogs"}
              >
                <i className="custom-icon icon-graph"></i> <Link to="/UserLogs">Logs</Link> 
              </MenuItem>

)}
              

              
              <Typography
                variant="h6"
                sx={{ m: "15px 0 5px 20px" }}
                className="menu_setting_section"
              >
                Settings
              </Typography>
              <SubMenu 
                title={<><i className="custom-icon icon-user"></i> Account</>}
                open={openSubMenu === 'Account'} 
                onOpen={() => setOpenSubMenu('Account')} 
                onClick={() => setOpenSubMenu('Account')}
              >
                 <MenuItem 
                  className={selectedMenuItem === 'ChangePassword' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('ChangePassword'); setOpenSubMenu('ChangePassword')}}
                  active={currentLocation.pathname === "/ChangePassword"}
                >
                  <Link to="/ChangePassword">Change Password</Link>
                </MenuItem> 

{isAdmin != 1 && (
                 <MenuItem 
                  className={selectedMenuItem === 'CountryAssignment' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('CountryAssignment'); setOpenSubMenu('CountryAssignment')}}
                  active={currentLocation.pathname === "/CountryAssignment"}
                >
                  <Link to="/CountryAssignment">Country Assignment</Link>
                </MenuItem> 
)}


                

                <MenuItem 
                  className={selectedMenuItem === 'Logout' ? 'active' : ''} 
                  onClick={handleLogout}
                >
                  <Link>Logout</Link>
                </MenuItem>                                   
              </SubMenu> 
          
            </Box>
          </Menu>
        </ProSidebar>
      </Box>
    </>
  );
};

export default Sidebar;
